import { PushNotificationModule } from '@common/push-notification/server/push-notification.module';
import { ErpSharedControlsModule } from '@app/features/erp-apps/erp-shared-controls/erp-shared-controls.module';
export const eagerProductModules: any[] = [PushNotificationModule,ErpSharedControlsModule];

export * from '@common/push-notification/server/push-notification.module';
export * from '@app/features/erp-apps/erp-shared-controls/erp-shared-controls.module';

